<div class="row">
  <div class="col-12">
    <div class="card card-body coupon-card">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <h4 class="card-title mb-0">
          <span class="lstick"></span> Coupons
        </h4>
        <button class="btn btn-primary" (click)="openModal(editModal, {}, 'Create Coupon')">
          + Create Coupon
        </button>
      </div>

      <div class="table-responsive mt-3">
        <table class="table table-striped border coupon-table">
          <thead>
            <tr>
              <th>Coupon Code</th>
              <th>Offers</th>
              <th>Limits</th>
              <th>Expire on</th>
              <th>Multiple Use?</th>
              <th>Free Shipping</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let d of data">
              <td>{{ d?.couponCode }}</td>
              <td>
                {{
                d?.couponType == "time"
                ? d?.time + " " + d?.type
                : d?.discountPercent + "%"
                }}
              </td>
              <td>{{ d?.limit }}</td>
              <td>{{ d?.expire_date | date : "dd/MM/yyyy" }}</td>
              <td>
                <span class="badge" [ngClass]="d?.isMultipleUse ? 'badge-success' : 'badge-secondary'">
                  {{ d?.isMultipleUse ? "Yes" : "No" }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="d?.freeShipping ? 'badge-success' : 'badge-secondary'">
                  {{ d?.freeShipping ? "Yes" : "No" }}
                </span>
              </td>
              <td class="action-icons">
                <i class="fa fa-edit" (click)="openModal(editModal, d, 'Edit Coupon')"></i>
                <i class="fa fa-trash text-danger" (click)="openModal(editModal, d, 'Delete Coupon')"></i>
              </td>
            </tr>

            <tr *ngIf="data.length == 0">
              <td colspan="6" class="text-center">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-center mt-4" *ngIf="data?.length">
        <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalcount" [maxSize]="5"
          [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage($event)">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- MODAL -->
<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()">&times;</button>
  </div>

  <div class="modal-body">
    <form *ngIf="modeltitle != 'Delete Coupon'" (ngSubmit)="onSubmit(specialityform)" #specialityform="ngForm">

      <!-- Coupon Code -->
      <div class="form-group">
        <label>Coupon Code</label>
        <small class="text-muted d-block mb-1" *ngIf="modeltitle == 'Create Coupon'">
          Use semicolon for multiple codes (Ex: c1;c2)
        </small>
        <input type="text" class="form-control" [(ngModel)]="detail.couponCode" name="couponCode" />
      </div>

      <!-- Free Shipping -->
      <div class="form-group">
        <label class="d-block mb-1">Free Shipping</label>
        <div class="d-flex gap-4">
          <label class="radio-box" style="margin-right: 10px;">
            <input type="radio" name="freeShipping" [value]="true" [(ngModel)]="detail.freeShipping" />
            Yes
          </label>
          <label class="radio-box">
            <input type="radio" name="freeShipping" [value]="false" [(ngModel)]="detail.freeShipping" />
            No
          </label>
        </div>
      </div>

      <!-- Discount -->
      <div class="form-group">
        <label>Discount (%)</label>
        <input type="number" class="form-control" [(ngModel)]="detail.discountPercent" name="discountPercent"
          required />
      </div>

      <!-- Limit -->
      <div class="form-group">
        <label>Limits</label>
        <input type="number" class="form-control" [(ngModel)]="detail.limit" name="limit" required />
      </div>

      <!-- Expire -->
      <div class="form-group">
        <label>Expire Date</label>
        <input type="date" class="form-control" [(ngModel)]="detail.expire_date" name="expire_date" required />
      </div>

      <!-- Multiple use -->
      <div class="form-group">
        <label class="checkbox-box">
          <input type="checkbox" [(ngModel)]="detail.isMultipleUse" name="isMultipleUse" />
          Have Multiple Use
        </label>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="closeBtnClick()">Close</button>
        <button type="submit" class="btn btn-primary" [disabled]="!specialityform.valid">Save</button>
      </div>
    </form>

    <!-- DELETE -->
    <div *ngIf="modeltitle == 'Delete Coupon'" class="text-center">
      <p>Are you sure you want to delete this coupon?</p>
      <div class="modal-footer justify-content-center">
        <button class="btn btn-light" (click)="closeBtnClick()">Cancel</button>
        <button class="btn btn-danger" (click)="delete()">Delete</button>
      </div>
    </div>
  </div>
</ng-template>